import { injectIntl } from 'react-intl';

import UnavailablePage from './UnavailablePage.page';

export default injectIntl(UnavailablePage);
